@if (!rows.length) {
  <div class="text-center py-4 text-muted">No portfolios available.</div>
} @else {
  <app-asset-table
    [simpleMode]="true"
    [list]="rows"
    [quantList]="quantList"
    [sorting]="sorting"
    (itemSelect)="onItemSelect($event)"
    (sortClicked)="onSortClick($event)"
  ></app-asset-table>
}
